<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Tävling</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-7">
            <div class="row">
                <label for="name" class="col-5">Namn</label>
                <div class="col-7">
                    <input id="" name [(ngModel)]="competition.CompetitionName">
                </div>
            </div>
            <div class="row">
                <label for="c_club" class="col-5">Tävlande klubb</label>
                <div class="col-7">
                    <input id="c_club" [(ngModel)]="competition.CompetingClub">
                </div>
            </div>
            <div class="row">
                <label for="v_club" class="col-5">Röstande klubb</label>
                <div class="col-7">
                    <input id="v_club" [(ngModel)]="competition.VotiingClub">
                </div>
            </div>
            <div class="row">
                <div class="col-12"><strong>Sista datum för:</strong></div>
            </div>
            <div class="row">
                <label for="uploaddate" class="col-5">Bilduppladdning</label>
                <div class="col-7">
                    <input id="uploaddate" type="date" [(ngModel)]="competition.EndoParticipation">
                </div>
            </div>

            <div class="row">
                <label for="votedate" class="col-5">Ingentävling diskussion/analys</label>
                <div class="col-7">
                    <input id="votedate" type="checkbox" [(ngModel)]="competition.ImageAnalysis">
                </div>
            </div>
            @if (!competition.ImageAnalysis) {
            <div class="row">
                <label for="votedate" class="col-5">Röstning</label>
                <div class="col-7">
                    <input id="votedate" type="date" [(ngModel)]="competition.EndOfVoting">
                </div>
            </div>
            }
            <div class="row">
                <label for="partcanupload" class="col-5">Deltagare kan lägga till bild</label>
                <div class="col-7">
                    <input id="partcanupload" type="checkbox" [(ngModel)]="competition.participantCanAddImage">
                </div>
            </div>
            @if (!competition.ImageAnalysis) {
            <div class="row">
                <label for="numvote" class="col-5">Antal röster</label>
                <div class="col-7">
                    <input id="numvote" type="number" [(ngModel)]="competition.numberOfVotes">
                </div>
            </div>
            <div class="row">
                <label for="numplace" class="col-5">Antal bilder som får placering</label>
                <div class="col-7">
                    <input id="numplace" type="number" [(ngModel)]="competition.numberOfPositionedImages"
                        (change)="fillSteps()">
                </div>
            </div>
            <div class="row">
                <label for="votcanseedate" class="col-5">Röstande kan se resultatet från och med</label>
                <div class="col-7">
                    <input id="votecanseedate" type="date" [(ngModel)]="competition.VisibleToVoterFrom">
                </div>
            </div>
            <div class="row">
                <label for="public" class="col-5">Resultatet blir publikt</label>
                <div class="col-7">
                    <input id="public" type="checkbox" [(ngModel)]="competition.PubliclyVisible">
                </div>
            </div>
            }
            <div class="row" *ngIf="competition.PubliclyVisible">
                <label for="publicdate" class="col-5">Resultatet blir publikt från och med</label>
                <div class="col-7">
                    <input id="publicdate" type="date" [(ngModel)]="competition.PubliclyVisibleFrom">
                </div>
            </div>
        </div>
        <div class="col-5">

            <div class="row" *ngFor="let step of steps">
                <label for="step" class="col-6">
                    Poäng för plats {{step.position}}
                </label>
                <div class="col-2">
                    <input id="step" type="number" [(ngModel)]="step.point" min="1" max="99">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="passBack()" type="submit" class="btn btn-primary" [disabled]="!validToSend">
        Ok
    </button>
</div>